// extracted by mini-css-extract-plugin
export default {"empty":"ResultsEmpty_empty__3KT+C","emptyDescription":"ResultsEmpty_emptyDescription__LVohh"};